import { createAction, createReducer } from 'redux-act';
import { delay } from 'shared/utils/utilHelper';

const initialState = {
  fetchLoading1: false,
  fetchLoading2: false,
  data1: [],
  data2: [],
  error1: false,
  error2: false,
  message1: '',
  message2: ''
};

const fetchOceanSpotRateAndFuelTable1 = createAction(
  'fetch ocean spot rate and fuel table 1'
);
const fetchOceanSpotRateAndFuelTable1Success = createAction(
  'fetch ocean spot rate and fuel table 1 success'
);
const fetchOceanSpotRateAndFuelTable1Error = createAction(
  'fetch ocean spot rate and fuel table 1 error'
);

const fetchOceanSpotRateAndFuelTable2 = createAction(
  'fetch ocean spot rate and fuel table 2'
);
const fetchOceanSpotRateAndFuelTable2Success = createAction(
  'fetch ocean spot rate and fuel table 2 success'
);
const fetchOceanSpotRateAndFuelTable2Error = createAction(
  'fetch ocean spot rate and fuel table 2 error'
);

export default createReducer(
  {
    [fetchOceanSpotRateAndFuelTable1]: (state) => ({
      ...state,
      fetchLoading1: true,
      error1: false
    }),
    [fetchOceanSpotRateAndFuelTable1Success]: (state, payload) => ({
      ...state,
      data1: payload,
      fetchLoading1: false,
      error1: false
    }),
    [fetchOceanSpotRateAndFuelTable1Error]: (state, payload) => ({
      ...state,
      message1: payload,
      error1: true,
      data1: [],
      fetchLoading1: false
    }),
    [fetchOceanSpotRateAndFuelTable2]: (state) => ({
      ...state,
      fetchLoading2: true,
      error2: false
    }),
    [fetchOceanSpotRateAndFuelTable2Success]: (state, payload) => ({
      ...state,
      data2: payload,
      fetchLoading2: false,
      error2: false
    }),
    [fetchOceanSpotRateAndFuelTable2Error]: (state, payload) => ({
      ...state,
      message2: payload,
      error2: true,
      data2: [],
      fetchLoading2: false
    })
  },
  initialState
);

export const fetchOceanSpotRateAndFuelTable1Action = () => {
  return async (dispatch) => {
    try {
      dispatch(fetchOceanSpotRateAndFuelTable1());
      await delay(1000);
      dispatch(fetchOceanSpotRateAndFuelTable1Success());
    } catch (error) {
      dispatch(fetchOceanSpotRateAndFuelTable1Error());
    }
  };
};

export const fetchOceanSpotRateAndFuelTable2Action = () => {
  return async (dispatch) => {
    try {
      dispatch(fetchOceanSpotRateAndFuelTable2());
      await delay(1000);
      dispatch(fetchOceanSpotRateAndFuelTable2Success());
    } catch (error) {
      dispatch(fetchOceanSpotRateAndFuelTable2Error());
    }
  };
};
